import React, { useState, useEffect } from "react";
import { Card, Table, Tag, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import AppleInAppPayments from "../../../components/subscription/AppleInAppPayments";

const { Text } = Typography;

const stateColor = (state) => {
  const value = String(state || "").toUpperCase();
  if (value === "APPROVED") {
    return "green";
  }
  if (["DEVELOPER_REMOVED_FROM_SALE", "REMOVED_FROM_SALE", "REJECTED"].includes(value)) {
    return "red";
  }
  return "orange";
};

function AppleInApp() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [error, setError] = useState("");

  const fetchSubscriptions = async () => {
    try {
      setLoading(true);
      setError("");
      const response = await api.get(
        "/admin/app-store/subscriptions",
        { timeout: 30000 }
      );
      const groups = Array.isArray(response?.data?.subscriptions)
        ? response.data.subscriptions
        : [];
      const flattened = groups.flatMap((group) =>
        (group.subscriptions || []).map((sub) => ({
          ...sub,
          groupId: group.groupId,
          groupName: group.groupName,
        }))
      );
      setSubscriptions(flattened);
    } catch (err) {
      console.error("Error fetching App Store subscriptions:", err);
      const errMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to load App Store subscriptions";
      setError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDetails = (record) => {
    navigate(`/apple-in-app/subscription/${record.id}`);
  };

  const columns = [
    {
      title: "Product ID",
      dataIndex: "productId",
      key: "productId",
      render: (value) => <Text strong>{value || "-"}</Text>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Group",
      dataIndex: "groupName",
      key: "groupName",
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      render: (value) => <Tag color={stateColor(value)}>{value || "-"}</Tag>,
    },
    {
      title: "Family Shareable",
      dataIndex: "familyShareable",
      key: "familyShareable",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Button
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            openDetails(record);
          }}
        >
          View Details
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Card
        title="App Store Subscriptions"
        extra={
          <Button loading={loading} onClick={fetchSubscriptions}>
            Refresh
          </Button>
        }
        style={{ marginBottom: "24px" }}
      >
        {error ? (
          <Text type="danger" style={{ display: "block", marginBottom: "12px" }}>
            {error}
          </Text>
        ) : null}
        <Table
          columns={columns}
          dataSource={subscriptions}
          loading={loading}
          rowKey="id"
          pagination={false}
          size="small"
          scroll={{ x: 800 }}
          onRow={(record) => ({
            onClick: () => openDetails(record),
            style: { cursor: "pointer" },
          })}
        />
      </Card>

      <AppleInAppPayments title="Transaction History" pageSize={20} />
    </div>
  );
}

export default AppleInApp;
